import BaseService from './base-service';

const resource = `/auth/v1`;

export default {
  getProfile() {
    return BaseService.get(`${resource}/profile`);
  },
  updateProfile(user) {
    return BaseService.put(`${resource}/profile`, user);
  },
};
